import api from '../..'

export const getTaskBlock = (blockId: number) => {
  return api.get(`block_task/block_instances/${blockId}`).then(
    ({
      data: {
        data: { attributes },
      },
    }) => {
      const {
        id,
        blockInstanceableId,
        content,
        blockInstanceable: { name, mandatory, order, description, blockInstanceableType },
        multipleFileUpload,
        respose,
      } = attributes
      return { id, blockInstanceableId, content, name, mandatory, order, description, type: blockInstanceableType, multiFile: multipleFileUpload, response: respose }
    }
  )
}
